import { useState } from "react";
import type { CauseOfDeathFilterFormState } from "../causeOfDeath.types";
import { CauseOfDeathStatusFilter } from "../utils/causeOfDeath.utils";

export function useFilterForm() {
  const [filterForm, setFilterForm] = useState<CauseOfDeathFilterFormState>({
    searchText: "",
    status: CauseOfDeathStatusFilter.Active,
  });

  const handleChangeFilter = <T extends keyof CauseOfDeathFilterFormState>(
    field: T,
    value: CauseOfDeathFilterFormState[T]
  ) => {
    setFilterForm((prev) => ({ ...prev, [field]: value }));
  };

  return {
    filterForm,
    handleChangeFilter,
  };
}
